/* eslint-disable-next-line max-len */
export const SCOPE: string = 'access.cloud.platform.organisation access.cloud.platform.users access.cloud.wff.launch access.widget.api email openid policy profile';
export const PRODUCT_ID: string = 'access.product.contracts.billing';
export const TOKEN_STORAGE_KEY: string = 'ag-access-token';

